import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-pencil",
  style: {"padding-left":"5px","font-size":"0.7em"}
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modal === 1 || _ctx.displayEditButton)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleModalDialog && _ctx.toggleModalDialog(...args)))
      }, [
        _createElementVNode("span", {
          id: "company-change-icon",
          class: "text-black h5",
          title: _ctx.$t('message.change')
        }, [..._hoisted_3], 8 /* PROPS */, _hoisted_1)
      ]))
    : _createCommentVNode("v-if", true)
}